/* eslint-disable @typescript-eslint/no-unused-vars */
import _114026_sparse from "../../../assets/projects/lincolncenter/map/114026-LC_middle_BLK2GO_scan2-sparse.ply";
import _114028_sparse from "../../../assets/projects/lincolncenter/map/114028-LC_topleft_BLK2GO_scan13-sparse.ply";
import _114031_sparse from "../../../assets/projects/lincolncenter/map/114031-LC_topright_BLK2GO_scan5-sparse.ply";
import _116507_sparse from "../../../assets/projects/lincolncenter/map/116507-LC_MET_20241219_edited-sparse.ply";
// import _114033_sparse from '../../../assets/projects/lincolncenter/map/114033-LC_middle_front1_BLK2GO_scan8-sparse.ply';
// import _114034_sparse from '../../../assets/projects/lincolncenter/map/114034-LC_middle_front2_BLK2GO_scan10-sparse.ply';
// import _114036_sparse from '../../../assets/projects/lincolncenter/map/114036-LC_middle_front3_BLK2GO_scan12-sparse.ply';
//
import PlazaMeshPath from "@lincolncenter/building/LC_LP_cut_no_textures.glb";

import {
  Angle,
  Camera,
  Color3,
  Engine,
  Mesh,
  Scene,
  StandardMaterial,
  Texture,
  Vector3,
} from "babylonjs";
import {
  IAssetBase,
  IAssetModel,
  IAssetPointCloud,
  IAssetTexture,
} from "../../apps/app.content";
import ContentLincolnCenterBase from "./content.lincolncenter.base";
import { IContentLincolnCenterConfig } from "./content.lincolncenter.config";

const MapMiddle = 114026;
const MapTopLeft = 114028;
const MapTopRight = 114031;
const MapMiddleFront1 = 114033;
const MapMiddleFront2 = 114034;
const MapMiddleFront3 = 114036;
const MapMet = 116507;

//----------------------------------------------------------------
export default class ContentLincolnCenterBuilding extends ContentLincolnCenterBase {
  protected assetsLoaded: IAssetBase[] = [];
  private placeholderMeshes: { [key: string]: Mesh } = {};
  private loadedTextures: { [key: string]: IAssetTexture } = {};

  protected config: IContentLincolnCenterConfig | undefined;

  constructor(config: IContentLincolnCenterConfig) {
    super();
    this.config = config;
  }

  public override get assets(): IAssetBase[] {
    return [
      // ...( (this.config && this.config.loadPointClouds) ? this.pointCloudAssets : []),
      {
        id: "building_mesh",
        type: "model",
        path: PlazaMeshPath,
      },
    ];
  }

  private get pointCloudAssets(): IAssetBase[] {
    return [
      {
        id: `immersal_sparse_${MapMiddle.toString()}`,
        type: "pointcloud",
        path: _114026_sparse,
        size: 2,
        color: Color3.Magenta().asArray(),
      } as IAssetPointCloud,
      {
        id: `immersal_sparse_${MapTopLeft.toString()}`,
        type: "pointcloud",
        path: _114028_sparse,
        size: 2,
        color: Color3.Yellow().asArray(),
      } as IAssetPointCloud,
      {
        id: `immersal_sparse_${MapTopRight.toString()}`,
        type: "pointcloud",
        path: _114031_sparse,
        size: 2,
        color: Color3.Teal().asArray(),
      } as IAssetPointCloud,
      // {
      //   id: MapMiddleFront1.toString(),
      //   type: "pointcloud",
      //   path: _114033_sparse,
      //   size: 2,
      //   color: Color3.Red().asArray(),
      // } as IAssetPointCloud,
      // {
      //   id: MapMiddleFront2.toString(),
      //   type: "pointcloud",
      //   path: _114034_sparse,
      //   size: 2,
      //   color: Color3.Green().asArray(),
      // } as IAssetPointCloud,
      // {
      //   id: MapMiddleFront3.toString(),
      //   type: "pointcloud",
      //   path: _114036_sparse,
      //   size: 2,
      //   color: Color3.Blue().asArray(),
      // } as IAssetPointCloud,
      // {
      //   id: `immersal_sparse_${MapMet.toString()}`,
      //   type: "pointcloud",
      //   path: _116507_sparse,
      //   size: 2,
      //   color: Color3.Green().asArray(),
      // }
    ];
  }

  public override init(engine: Engine, scene: Scene, camera: Camera): void {
    super.init(engine, scene, camera);
  }

  public loadAssetComplete(assetLoaded: IAssetBase): void {
    const assetIndex = this.assets.findIndex(
      (asset) => asset.id === assetLoaded.id
    );
    if (assetIndex >= 0) {
      this.assetsLoaded.push(assetLoaded);
    }

    if (assetLoaded.id === "building_mesh") {
      const assetModel = assetLoaded as IAssetModel;
      
      if (assetModel.meshes) {
        assetModel.meshes.forEach((mesh) => {
          mesh.receiveShadows = true;
          mesh.isPickable = false;
        });
      }
    }

  }

  private pointCloudAlignment(assetLoaded: IAssetBase) {
    const transformPointCloud = (
      asset: IAssetPointCloud,
      pos: Vector3,
      rot: Vector3
    ) => {
      if (asset.mesh) {
        asset.mesh.position.copyFrom(pos);
        asset.mesh.rotation.copyFrom(rot);
      }
    };

    this.config?.maps.forEach((map) => {  
      if (assetLoaded.id?.endsWith(map.mapId.toString())) {
        if (map && map.position && map.rotation)
          transformPointCloud(
            assetLoaded as IAssetPointCloud,
            new Vector3(map.position![0], map.position![1], map.position![2]),
            new Vector3(map.rotation![0], map.rotation![1], map.rotation![2])
          );
      }
    });

    return;



    if (assetLoaded.id?.endsWith(MapMiddle.toString())) {
      transformPointCloud(
        assetLoaded,
        new Vector3(-33.486, 1.62, 76.9),
        new Vector3(0, Angle.FromDegrees(81.9).radians(), 0)
      );
    } else if (assetLoaded.id?.endsWith(MapTopLeft.toString())) {
      transformPointCloud(
        assetLoaded,
        new Vector3(-28, 1.0, 8.5),
        new Vector3(0, Angle.FromDegrees(272.3).radians(), 0)
      );
    } else if (assetLoaded.id?.endsWith(MapTopRight.toString())) {
      transformPointCloud(
        assetLoaded,
        new Vector3(-7.1, 2, -56.6),
        new Vector3(0, Angle.FromDegrees(113).radians(), 0)
      );
    } else if (assetLoaded.id?.endsWith(MapMiddleFront1.toString())) {
      transformPointCloud(
        assetLoaded,
        new Vector3(-72.2, 1.6, 80),
        new Vector3(0, Angle.FromDegrees(102).radians(), 0)
      );
    } else if (assetLoaded.id?.endsWith(MapMiddleFront2.toString())) {
      transformPointCloud(
        assetLoaded,
        new Vector3(-79, 2, -1),
        new Vector3(0, Angle.FromDegrees(209.9).radians(), 0)
      );
    } else if (assetLoaded.id?.endsWith(MapMiddleFront3.toString())) {
      transformPointCloud(
        assetLoaded,
        new Vector3(-32.5, 1.6, 9.1),
        new Vector3(0, Angle.FromDegrees(103).radians(), 0)
      );
    }
  }
}
